export const COMPANY_NAME = 'RevoFrame Inc';
export const COMPANY_SHORT = 'RevoFrame';
export const COMPANY_INITIALS = 'RF';
export const COMPANY_ADDRESS_FULL = '6263 Topanga Canyon Blvd, Suite 509, Woodland Hills, CA 91367';
export const COMPANY_LOCATION = 'Woodland Hills, CA';
export const COMPANY_REGION = 'California';
export const FILING_DATE = 'June 4, 2025';
export const FILE_NUMBER = 'B20250151363';
export const ENTITY_TYPE = 'California close corporation';
export const AGENT_NAME = 'Vladislav Philippov';
export const AUTHORIZED_SHARES = '100';
export const MAP_URL = 'https://www.google.com/maps/search/?api=1&query=6263%20Topanga%20Canyon%20Blvd%20509%20Woodland%20Hills%20CA%2091367';
export const HERO_IMAGE_URL = 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1800&q=80';

export const PROFILE_FACTS = [
  { label: 'File No.', value: FILE_NUMBER },
  { label: 'Filed', value: FILING_DATE },
  { label: 'Entity', value: ENTITY_TYPE },
  { label: 'Authorized shares', value: AUTHORIZED_SHARES },
];

export const PUBLIC_INFO = [
  { label: 'Corporation name', value: COMPANY_NAME },
  { label: 'Principal office', value: COMPANY_ADDRESS_FULL },
  { label: 'Mailing address', value: COMPANY_ADDRESS_FULL },
  { label: 'Agent for service', value: AGENT_NAME },
];

export const RECORD_POINTS = [
  {
    eyebrow: 'Purpose',
    title: 'Lawful business activity',
    body: 'The articles state that the corporation may engage in any lawful act or activity permitted under California General Corporation Law, excluding banking, trust company business, and professional corporation activities.',
  },
  {
    eyebrow: 'Ownership structure',
    title: 'Close corporation status',
    body: 'The filing identifies RevoFrame Inc as a close corporation whose issued shares will be held of record by no more than two persons.',
  },
  {
    eyebrow: 'Capitalization',
    title: 'Single share class',
    body: 'The corporation is authorized to issue 100 shares and the filing indicates that it does not have more than one class or series of shares.',
  },
];

export const TIMELINE = [
  { label: 'Articles prepared', value: 'California Secretary of State form' },
  { label: 'Electronic signature', value: 'Vladislav Philippov' },
  { label: 'Date filed', value: FILING_DATE },
];
